import React from 'react';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { useClienteAuth } from '../context/ClienteAuthContext';

const MisCompras = () => {
    const { cliente } = useClienteAuth();

    return (
        <div className="ec-container" style={{ padding: '2rem 0' }}>
            <h2 style={{ marginBottom: 16 }}>Mis compras</h2>
            {!cliente ? (
                <Message severity="warn" text="Inicia sesión para ver tu historial de compras." style={{ width: '100%' }} />
            ) : (
                <Card>
                    <p style={{ margin: 0 }}>
                        Aún no hay historial conectado al backend para este módulo.
                    </p>
                </Card>
            )}
        </div>
    );
};

export default MisCompras;
